<template>
  <div>
    <el-row class="obpm-fromContent-title obpm-enterpriseDomain-logo normalHeight">
      <el-col :span="12" class="normalLineH">
        <span>基本信息</span>
      </el-col>
      <el-col :span="12" class="align-right normalLineH">
        <span class="toolbar-buttons">
          <!-- <el-button type="primary" @click="syncLDAPInfo" size="small" v-if="$route.query.showLdapButton">同步LDAP信息</el-button> -->
          <el-button type="primary" @click="onSave('form')" size="small">{{$t('save')}}</el-button>
          <!-- <el-button @click="onUserImport" size="small">用户导入/导出</el-button> -->
          <!-- <el-button
              @click="$router.push({ name: 'main'})"
              size="small"
              type="primary"
              plain
              v-if="isCanExit"
          >{{$t('exit')}}</el-button> -->
        </span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="toolbar-title">{{$t('base_info_setting')}}</el-col>
    </el-row>
    <el-form
        ref="form"
        :model="content"
        label-position="top"
        label-width="140px"
        size="small"
        :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item :label="$t('enterprise_name')" class="padding0Label" prop="name">
            <el-input v-model="content.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item :label="$t('smsMemberCode')" class="marginBot0">
            <el-input v-model="content.smsMemberCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="4">
          <el-form-item :label="$t('smsMemberPwd')" class="marginBot0">
            <el-input type="password" v-model="content.smsMemberPwd"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" :offset="0">
          <el-form-item class="marginTop29 marginBot0">
            <el-button
              type="primary"
              plain
              class="obpm-btn obpm-btn-default"
              @click="testSMS"
            >{{$t('testSMS')}}</el-button>
          </el-form-item>
        </el-col>
      </el-row> -->
      <!-- <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item class="padding0Label">
            <a
                href="http://sms.teemlink.com/sms/register/register.jsp"
                target="_blank"
                class="tip-text"
            >[{{$t('noAccount')}}]</a>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="4">
          <el-form-item class="padding0Label">
            <a
                href="http://sms.teemlink.com/sms/"
                target="_blank"
                class="tip-text"
            >[{{$t('wantToChangePwd')}}]</a>
          </el-form-item>
        </el-col>
      </el-row> -->

      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item  :label="$t('systemName')" class="padding0Label">
            <el-input v-model="content.systemName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="4">
          <el-form-item :label="$t('description')" class="padding0Label">
            <el-input type="textarea" autosize v-model="content.description"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="6" v-if="isSuper" style="display:none">
          <el-form-item :label="$t('status')" class="padding0Label">
            <el-switch v-model="content.status"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="Logo(60 x 60)：" class="padding0Label">
            <input type="hidden" name="content.logoUrl" value />
            <input type="hidden" id="logo" name="content.logoUrl" />
            <div class="adminLogo" v-if="logoUrl=='img'">
              <img class="verticalBottom adminLogoImg" id="_iconImg" alt :src="content.logoUrl" v-if="content.logoUrl!=''"/>
            </div>
            <el-button class="obpm-btn-default mr-1" plain @click="selectIcon" type="primary">{{$t('choose')}}</el-button>
            <el-button type="danger" plain @click="cleanIcon">{{$t('clean')}}</el-button>
          </el-form-item>
        </el-col>
      </el-row> 

      <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item class="padding0Label">
                  <span>上级</span><el-button size="mini" @click="handleClick">{{$t('setSuperior')}}</el-button>
                  <!-- 上级 -->
                  <el-table
                    v-if="superiorTags.length > 0"
                    :data="superiorTags"
                    stripe
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="domainname"
                      label="组织名称">
                    </el-table-column>
                    <el-table-column
                      prop="code"
                      label="统一社会信用代码">
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="100">
                      <template slot-scope="scope">
                        <el-button @click="handleClose(scope.row.domainid,'parent')" type="text" size="small">解除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
          </el-col>
          <el-col :span="6" :offset="4">
            <el-form-item :label="$t('subordinate')" class="padding0Label">
                  <el-table
                    v-if="childsTags.length > 0"
                    :data="childsTags"
                    stripe
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="domainname"
                      label="组织名称">
                    </el-table-column>
                    <el-table-column
                      prop="code"
                      label="统一社会信用代码">
                    </el-table-column>
                    <el-table-column
                      label="操作"
                      width="100">
                      <template slot-scope="scope">
                        <el-button @click="handleClose(scope.row.domainid,'child')" type="text" size="small">解除</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <extend_flex 
          :contextPath="contextPath"
          :fieldextends="fieldextends"
          :content="content"
        />
      
    </el-form>
    <icon_select
        :visible.sync="iconSelectCheck"
        :logoUrl="content.logoUrl"
        @select-ok="onSelectIconOk"
        v-if="iconSelectCheck"
    />
    <setting_domain
        v-if="domainVisible"
        :visible.sync="domainVisible"
        :dialogTitle="dialogTitle"
        :parentList="parentList"
        @selectChecked="selectChecked"
    />
  </div>
</template>

<script>
import cityOptions from '@/assets/js/cityData';
import icon_select from "@/components/icon_select.vue";
import setting_domain from "@/components/setting_domain.vue";
import extend_flex from "@/components/extendFlex.vue";
import contextPath from "@/contextPath.js"
export default {
  components: {
    icon_select,
    setting_domain,
     extend_flex,
  },
  created() {
    if (window.location.href.split("&")[1]) {
      if (window.location.href.split("&")[1].indexOf("obpm") != -1) {
        this.isCanExit = false;
      }
    }
    this.getDomainData(true);
    this.isSuper = this.$store.state.currentUser.type=="super"?true:false;
  },
  data() {
    var nameCheck = (rule, value, callback) => {
      let re = /[^a-zA-Z0-9_\(\)\（\）\u4e00-\u9fa5]/;
      if (!value) {
        return callback(new Error("域(租户)名称不能为空"));
      } else if (re.test(value)) {
        return callback(new Error("域(租户)名称不能含有特殊字符"));
      } else {
        return callback();
      }
    };
    return {
      cityOptions: cityOptions, // 联动数据
      contextPath:this.$api.getContextPath(),
      content: {},
      iconSelectCheck: false,
      domainVisible: false,
      dialogTitle: '',
      domainParentId: '',//获取上级的id
      domainChildId: '',//获取下级的id
      parentList: '',  //获取上级域
      childList: '',   //获取下级域
      logoUrl: "img",
      fieldextends: [],
      fontIconColor: "#000000",
      skins: [],
      options:[],
      radioValue:'',
      selectValue:'',
      superiorTags: [], //上级标签
      childsTags: [], //下级标签
      juniorTags: [],
      rules: {
        name: [
          { required: true, message: "请先填写域(租户)名称", trigger: "blur" },
          {
            validator: nameCheck,
            message: "域(租户)名称不能含有特殊字符",
            trigger: "blur",
          },
        ],
      },
      isCanExit: true,
      nowOption:"depImport",
      uploadUrl:"/authtime/uploads",
      filePath: "/uploads/lib/img",
      fileData:{
        path:'/uploads/lib/img',
        filePath:'/uploads/lib/img',
      },
      isShow:false,
      activeIndex:-1,
      imgBase:'',
      dialogImageUrl: '',
      dialogVisible: false,
      isSuper: false, //是否是管理员
    };
  },
  computed: {
    status: {
      get() {
        return this.content.status == 1;
      },
      set(value) {
        console.log(value)
        this.content.status = value ? 1 : 0;
      },
    },
  },

  methods: {
    /**
         * 改变注册地址的省市区
         */
        changeRegisterProvince(item){
          if(item){
            if (item.length === 2) {
              this.content.registerProvince = item[0]
              this.content.registerCity = item[1]
            } else if (item.length === 3) {
              this.content.registerProvince = item[0]
              this.content.registerCity = item[1]
              this.content.registerDistrict = item[2]
            }
          }
        },
        /**
         * 改变经营地址的省市区
         */
        changeManageProvince(item){
          if(item){
            if (item && item.length === 2) {
              this.content.manageProvince = item[0]
              this.content.manageCity = item[1]
            } else if (item.length === 3) {
              this.content.manageProvince = item[0]
              this.content.manageCity = item[1]
              this.content.manageDistrict = item[2]
            }
          }
        },
        /**
     * 获取企业域信息
     */
    getDomainData(val){
      this.$api.getDomain(this.$route.query.domainid, {
        onSucess: (resp) => {
          this.content = resp.data.data;
          this.superiorTags = resp.data.data.parents;
          this.childsTags = resp.data.data.childs;
          if(val){
            this.getFieldList();
          }
          if (this.content.logoUrl.indexOf("#") != -1) {
            this.logoUrl = "icon";
            this.fontIconColor = this.content.logoUrl.slice(
              this.content.logoUrl.indexOf("#")
            );
            this.content.logoUrl = this.content.logoUrl.replace(
              /#[0-9a-zA-Z]{6}/,
              ""
            );
          }
          console.log(this.fieldextends)
          for(let i=0;i<this.fieldextends.length;i++){
            if(this.fieldextends[i].type == "address"){
              let provinceAddress = this.content[this.fieldextends[i].name].split(',')
              let arr = [];
              arr.push(provinceAddress[0],provinceAddress[1],provinceAddress[2])
              this.content[this.fieldextends[i].name] = arr;
              this.content[this.fieldextends[i].name+'_registerAddress'] = provinceAddress[3]
            }
          }
        },
      });
    },
    getFieldList() {
      let that = this;
      let dataJson={ 
        currpage:1,
        pagelines:10,
        data:{
          type:"",
          fortable:"tableDomain",
          domainid: this.$route.query.domainid,
          belong:"All"
        }
      }
      /**
       * 获取字段拓展
       */
      this.$api.getFieldExtends(
        dataJson,
        {
          onSucess: resp => {
            resp.data.data.datas.forEach( elm => {
              if(elm.type == "radio" || elm.type == "select" || elm.type == "checkbox"){
                let option = elm.options.split(";");
                let arr = [];
                if(elm.type == "radio" || elm.type == "select") {
                  for(let i=0;i<option.length;i++){
                    let obj = {}
                    obj.label = option[i];
                    obj.value = option[i];
                    arr.push(obj);
                  }
                  elm.options = arr;
                } else if(elm.type == "checkbox") {
                  elm.checkboxList = that.content[elm.name].split(";");
                  elm.options = option;
                }
              } else if(elm.type == "address") {
                // debugger
                this.content[elm.name+'_registerAddress'] = this.content[elm.name].split(',')[3];
                let arr = [];
                arr.push(this.content[elm.name].split(',')[0],this.content[elm.name].split(',')[1],this.content[elm.name].split(',')[2])
                this.content[elm.name] = arr;
              }
              that.fieldextends.push(elm);
            })
            this.$forceUpdate();
          }
        }
      );
    },
    syncLDAPInfo(){
      this.$api.asyncLDAP(this.$route.query.domainid, {
        onSucess: response => {
          if(response.data.errcode == 0){
            this.$message.success(response.data.errmsg)
          }else{
            this.$message.warning(response.data.errmsg)
          }
        }
      });
    },
    /**
     * 复选框选中
     */
    hanleChange(val,fieldName){
      let checkboxValue = ""
      for(let i=0;i<val.length;i++){
        if(checkboxValue){
          checkboxValue = checkboxValue + ";" + val[i];
        }else{
          checkboxValue = val[i];
        }
      }
      this.content[fieldName] = checkboxValue;
    },
    fileSuccess(response, name){
      let that = this;
      let file = response.data[0];
      that.content[name] = file.filePath;
    },
    getFileUrl(){
      return this.$api.getLogoUrl(this.uploadUrl+"?path="+this.filePath+"&icon=true")
    },
    changeActive(index) {
      this.activeIndex = index;
			this.isShow = true;
		},
    removeActive() {
			this.isShow = false;
		},
    /**
     * 点击预览
     */
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    opendialog(name){
      this.content[name] = '';
    },
    /**
     * 获取上下级数据
     */
    handleClick(){
      let parentsId = "";
      if(this.domainListId){
        parentsId = this.domainListId;
      }else{
        let parents = this.content.parents;
        parents.map((item)=>{
          if(parentsId){
            parentsId = parentsId + ";" +item.domainid;
          }else{
            parentsId = item.domainid;
          }
        })
      }
      this.parentList = parentsId;
      this.dialogTitle = "设置上级";
      this.domainVisible = true;
    },
    /**
     * 删除上下级企业域标签
     */
    handleClose(tagId,type){
      let domainid = this.$route.query.domainid;
      let obj = {
        removeId: tagId,
        belong: type
      }
      this.$api.deleteRelation(domainid,{
          data: obj
        },{
        onSucess: response => {
          if(response.data.errcode == 0){
            this.$message({
              message: response.data.data,
              type: "success",
            });
            this.getDomainData();
          }
        }
      });
    },
    /**
     * 保存上下级返回数据
     */
    selectChecked(val,type){
      let domainid = this.$route.query.domainid;
      this.saveBaseinfo(domainid,val,type);
    },
    /**
     * 保存企业域信息
     */
    saveBaseinfo(domainid,selectValue,type){
      // 判断当前项是否为必填项
      let checkArr = []
      let checkTip = ""
      let have = true
      if(this.fieldextends.length > 0){
        this.fieldextends.map(item => {
          if(item.isNotNull){
            checkArr.push(item)
          }
          if(item.type == "address"){
            console.log(this.content)
            console.log(this.content[item.name+'_registerAddress'])
            this.content[item.name]
            if(this.content[item.name+'_registerAddress']){
              if(typeof(this.content[item.name]) == "string"){
                this.content[item.name] = this.content[item.name] + "," + this.content[item.name+'_registerAddress'];
              }else{
                this.content[item.name].push(this.content[item.name+'_registerAddress'])
              }
            }
            this.content[item.name] = this.content[item.name].toString();
          }
        })
        if(checkArr.length > 0){
          checkArr.some(ele => { if(!this.content[ele.name]){
            have = false
            checkTip += ele.label + ','
          } })
        }
        if(!have){
          this.$message.error(checkTip.substring(0, checkTip.lastIndexOf(',')) + '字段为必填项')
          return false;
        }
      }
      // debugger
      if (domainid) {
        //当是选择上下级时，不需要回到主页
        if(type){
          if(type == "parent"){
            let ChildsId = "";
            let childs = this.content.childs ? this.content.childs : [];
            childs.map((item)=>{
              if(ChildsId){
                ChildsId = ChildsId + ";" +item.domainid;
              }else{
                ChildsId = item.domainid;
              }
            })
            this.domainParentId = selectValue;
            this.domainChildId = ChildsId;
          }else{
            let parentsId = "";
            let parents = this.content.parents;
            parents.map((item)=>{
              if(parentsId){
                parentsId = parentsId + ";" +item.domainid;
              }else{
                parentsId = item.domainid;
              }
            })
            this.domainParentId = parentsId;
            this.domainChildId = selectValue;
          }
        }
        //更新
        let content = {
          ...this.content,
          "description": this.content.description,
          "id": this.content.id,
          "logoUrl": this.content.logoUrl,
          "name": this.content.name,
          "smsMemberCode": this.content.smsMemberCode,
          "smsMemberPwd": this.content.smsMemberPwd,
          // "status": this.content.status,
          "status": 1,//默认选中
          "systemName": this.content.systemName,
          "users": this.content.users,
          "field1":this.content.field1?this.content.field1:null,
          "field2":this.content.field2?this.content.field2:null,
          "field3":this.content.field3?this.content.field3:null,
          "field4":this.content.field4?this.content.field4:null,
          "field5":this.content.field5?this.content.field5:null,
          "field6":this.content.field6?this.content.field6:null,
          "field7":this.content.field7?this.content.field7:null,
          "field8":this.content.field8?this.content.field8:null,
          "field9":this.content.field9?this.content.field9:null,
          "field10":this.content.field10?this.content.field10:null,
          "field11":this.content.field11?this.content.field11:null,
          "field12":this.content.field12?this.content.field12:null,
          "field13":this.content.field13?this.content.field13:null,
          "field14":this.content.field14?this.content.field14:null,
          "field15":this.content.field15?this.content.field15:null,
          "field16":this.content.field16?this.content.field16:null,
          "field17":this.content.field17?this.content.field17:null,
          "field18":this.content.field18?this.content.field18:null,
          "field19":this.content.field19?this.content.field19:null,
          "field20":this.content.field20?this.content.field20:null,
          "parents":this.domainParentId?this.domainParentId:[],
          "childs":this.domainChildId?this.domainChildId:[]
        }
        this.$api.updateDomain(domainid, content, {
          onSucess: (resp) => {
            if (resp && resp.data.errcode == 0) {
              this.$message({
                showClose: true,
                message: this.$t('msg_save_success'),
                type: "success",
              });
              if (this.isCanExit) {
                this.getDomainData();
                // this.$router.push({ name: "main" });
                // 修改为请求

              }else if(this.domainListId !=""){
                this.getDomainData();
              }
            } else {
              this.$message({
                message: resp.data.errmsg,
                type: "error",
              });
            }
          },
        });
      } else {
        //新建
        let content = {
          ...this.content,
          "description": this.content.description,
          "id": this.content.id,
          "logoUrl": this.content.logoUrl,
          "name": this.content.name,
          "smsMemberCode": this.content.smsMemberCode,
          "smsMemberPwd": this.content.smsMemberPwd,
          // "status": this.content.status,
          "status": 1,//默认选中
          "systemName": this.content.systemName,
          "users": this.content.users,
          "field1":this.content.field1?this.content.field1:null,
          "field2":this.content.field2?this.content.field2:null,
          "field3":this.content.field3?this.content.field3:null,
          "field4":this.content.field4?this.content.field4:null,
          "field5":this.content.field5?this.content.field5:null,
          "field6":this.content.field6?this.content.field6:null,
          "field7":this.content.field7?this.content.field7:null,
          "field8":this.content.field8?this.content.field8:null,
          "field9":this.content.field9?this.content.field9:null,
          "field10":this.content.field10?this.content.field10:null,
          "field11":this.content.field11?this.content.field11:null,
          "field12":this.content.field12?this.content.field12:null,
          "field13":this.content.field13?this.content.field13:null,
          "field14":this.content.field14?this.content.field14:null,
          "field15":this.content.field15?this.content.field15:null,
          "field16":this.content.field16?this.content.field16:null,
          "field17":this.content.field17?this.content.field17:null,
          "field18":this.content.field18?this.content.field18:null,
          "field19":this.content.field19?this.content.field19:null,
          "field20":this.content.field20?this.content.field20:null,
          "parents":selectValue?selectValue:[],
        }
        this.$api.createDomain(content, {
          onSucess: (resp) => {
            if (resp && resp.data.errcode == 0) {
              this.$message({
                message: this.$t('msg_save_success'),
                type: "success",
              });
              this.getDomainData();
              // this.$router.push({ name: "main" });
            } else {
              this.$message({
                message: resp.data.errmsg,
                type: "error",
              });
            }
          },
        });
      }
    },
    onSave(formName) {
      let domainid = this.$route.query.domainid;
      if (this.logoUrl == "icon") {
        this.content.logoUrl = this.content.logoUrl + this.fontIconColor;
      }
      // 判断当前项是否为必填项
      let checkArr = []
      let checkTip = ""
      let have = true
      if(this.fieldextends.length > 0){
        this.fieldextends.map(item => {
          if(item.isNotNull){
            checkArr.push(item)
          }
        })
        if(checkArr.length > 0){
          checkArr.some(ele => { if(!this.content[ele.name]){
            have = false
            checkTip += ele.label + ','
          } })
        }
        if(!have){
          this.$message.error(checkTip.substring(0, checkTip.lastIndexOf(',')) + '字段为必填项')
          return false;
        }
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveBaseinfo(domainid)
        }
      });
    },
    testSMS() {
      this.$prompt("请输入手机号码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^1\d{10}$/,
        inputErrorMessage: "手机号码格式不正确",
      })
        .then(({ value }) => {
          this.$api.testSMS(this.content.id, value, {
            onSucess: (resp) => {
              if (resp && resp.data.data.type == "success") {
                this.$message({
                  message: "发送成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: "发送失败",
                  type: "error",
                });
              }
            },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    selectIcon() {
      this.iconSelectCheck = true;
    },
    cleanIcon() {
      this.content.logoUrl = "";
    },
    onSelectIconOk(item) {
      if (item) {
        if (item.path) {
          this.logoUrl = "img";
          this.content.logoUrl = this.$api.getLogoUrl(item.path);
        } else if (item.filePath) {
          this.logoUrl = "img";
          this.content.logoUrl = this.$api.getLogoUrl(item.filePath);
        } else {
          this.$message({
            type: "error",
            message: "选择失败",
          });
        }
      }
    },
  },
};
</script>
<style scoped>
@import "../assets/css/font-awesome.min.css";
</style>
<style lang="scss" scoped>
</style>